var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "billInfo-page" },
    [
      _c("ul", { staticClass: "nav" }, [
        _c("li", { class: [_vm.lang] }, [
          _vm._v(_vm._s(_vm.$t("BillingInformation"))),
        ]),
      ]),
      _c(
        "a-spin",
        {
          attrs: {
            size: "large",
            spinning: _vm.loading,
            wrapperClassName: "global-spin-wrapper",
          },
        },
        [
          _c(
            "div",
            { staticClass: "subscribe-page" },
            [
              _c("a-card", { staticClass: "main-card" }, [
                !_vm.form.id
                  ? _c("div", { staticClass: "safeTips" }, [
                      _c("div", { staticClass: "title1", class: [_vm.lang] }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("CompleteBillingInfo")) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "cont", class: [_vm.lang] }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("BillingAddressRequired")) + " "
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c(
                        "a-form-model",
                        {
                          ref: "form",
                          staticClass: "billing-form",
                          attrs: {
                            model: _vm.form,
                            rules: _vm.rules,
                            "label-col": { span: 24 },
                            "wrapper-col": { span: 24 },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "billInfo",
                              staticStyle: { "margin-bottom": "20px" },
                            },
                            [
                              _c("div", { staticClass: "section-title" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("BillingContact"))),
                                ]),
                              ]),
                              _vm.form.id && !_vm.edit
                                ? _c(
                                    "div",
                                    { staticClass: "readonly-view" },
                                    [
                                      _c(
                                        "a-row",
                                        {
                                          staticClass: "ro-row",
                                          attrs: { gutter: 16 },
                                        },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("UserType"))
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "account-tag",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.form
                                                            .is_personal == 2
                                                            ? _vm.$t(
                                                                "ForEnterprises"
                                                              )
                                                            : _vm.$t(
                                                                "Soloentrepreneur"
                                                              )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("Firstname"))
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.form.first_name)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        {
                                          staticClass: "ro-row",
                                          attrs: { gutter: 16 },
                                        },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("lastName"))
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.form.last_name)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("Email"))
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [_vm._v(_vm._s(_vm.form.email))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        {
                                          staticClass: "ro-row",
                                          attrs: { gutter: 16 },
                                        },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("industry"))
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getIndustryName()
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm.form.is_personal == 2
                                            ? _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "ro-label" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("Companyname")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ro-value" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.form.company_name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm.form.is_personal == 2
                                        ? _c(
                                            "a-row",
                                            {
                                              staticClass: "ro-row",
                                              attrs: { gutter: 16 },
                                            },
                                            [
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "ro-label" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("Companysize")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ro-value" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.companyList[
                                                              _vm.form.size_id
                                                            ]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "ro-label" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("Positon")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "ro-value" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getRoleName()
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.form.id || _vm.edit
                                ? [
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "5",
                                                attrs: {
                                                  label: _vm.$t("UserType"),
                                                  prop: "is_personal",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select",
                                                  {
                                                    attrs: {
                                                      placeholder:
                                                        _vm.$t(
                                                          "SelectUserType"
                                                        ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.is_personal,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "is_personal",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.is_personal",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a-select-option",
                                                      {
                                                        key: "1111",
                                                        class: [_vm.lang],
                                                        attrs: { value: "1" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Soloentrepreneur"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "a-select-option",
                                                      {
                                                        key: "1112",
                                                        class: [_vm.lang],
                                                        attrs: { value: "2" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "ForEnterprises"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "1",
                                                attrs: {
                                                  label: _vm.$t("Firstname"),
                                                  prop: "first_name",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t("EnterFirst"),
                                                  },
                                                  model: {
                                                    value: _vm.form.first_name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "first_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.first_name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "2",
                                                attrs: {
                                                  label: _vm.$t("lastName"),
                                                  prop: "last_name",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t("EnterLastName"),
                                                  },
                                                  model: {
                                                    value: _vm.form.last_name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "last_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.last_name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "6",
                                                attrs: {
                                                  label: _vm.$t("Email"),
                                                  prop: "email",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t("enterEmail"),
                                                  },
                                                  model: {
                                                    value: _vm.form.email,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "email",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.email",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.form.is_personal == 1
                                      ? _c(
                                          "a-row",
                                          { attrs: { gutter: 16 } },
                                          [
                                            _c(
                                              "a-col",
                                              { attrs: { xs: 24, sm: 12 } },
                                              [
                                                _c(
                                                  "a-form-model-item",
                                                  {
                                                    key: "7",
                                                    attrs: {
                                                      label: _vm.$t("industry"),
                                                      prop: "industry_id",
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a-select",
                                                      {
                                                        attrs: {
                                                          placeholder:
                                                            _vm.$t(
                                                              "selectInstry"
                                                            ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .industry_id,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "industry_id",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.industry_id",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.industryList,
                                                        function (item, index) {
                                                          return _c(
                                                            "a-select-option",
                                                            {
                                                              key: index,
                                                              class: [_vm.lang],
                                                              attrs: {
                                                                value: index,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(item) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.form.industry_id == 15
                                              ? _c(
                                                  "a-col",
                                                  { attrs: { xs: 24, sm: 12 } },
                                                  [
                                                    _c(
                                                      "a-form-model-item",
                                                      {
                                                        key: "8",
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "Enteryourindustry"
                                                            ),
                                                          prop: "industry_desc",
                                                          required: "",
                                                        },
                                                      },
                                                      [
                                                        _c("a-input", {
                                                          attrs: {
                                                            placeholder: _vm.$t(
                                                              "Pleaseenteryourindustry"
                                                            ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form
                                                                .industry_desc,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "industry_desc",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.industry_desc",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.form.is_personal == 2
                                      ? _c(
                                          "a-row",
                                          { attrs: { gutter: 16 } },
                                          [
                                            _c(
                                              "a-col",
                                              { attrs: { xs: 24, sm: 12 } },
                                              [
                                                _c(
                                                  "a-form-model-item",
                                                  {
                                                    key: "7",
                                                    attrs: {
                                                      label: _vm.$t("industry"),
                                                      prop: "industry_id",
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a-select",
                                                      {
                                                        attrs: {
                                                          placeholder:
                                                            _vm.$t(
                                                              "selectInstry"
                                                            ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .industry_id,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "industry_id",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.industry_id",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.industryList,
                                                        function (item, index) {
                                                          return _c(
                                                            "a-select-option",
                                                            {
                                                              key: index,
                                                              class: [_vm.lang],
                                                              attrs: {
                                                                value: index,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(item) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.form.industry_id == 15
                                              ? _c(
                                                  "a-col",
                                                  { attrs: { xs: 24, sm: 12 } },
                                                  [
                                                    _c(
                                                      "a-form-model-item",
                                                      {
                                                        key: "8",
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "Enteryourindustry"
                                                            ),
                                                          prop: "industry_desc",
                                                          required: "",
                                                        },
                                                      },
                                                      [
                                                        _c("a-input", {
                                                          attrs: {
                                                            placeholder: _vm.$t(
                                                              "Pleaseenteryourindustry"
                                                            ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form
                                                                .industry_desc,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "industry_desc",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.industry_desc",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm.form.is_personal == 2 &&
                                                _vm.form.industry_id != 15
                                              ? _c(
                                                  "a-col",
                                                  { attrs: { xs: 24, sm: 12 } },
                                                  [
                                                    _c(
                                                      "a-form-model-item",
                                                      {
                                                        key: "3",
                                                        attrs: {
                                                          label:
                                                            _vm.$t(
                                                              "Companyname"
                                                            ),
                                                          prop: "company_name",
                                                          required: "",
                                                        },
                                                      },
                                                      [
                                                        _c("a-input", {
                                                          attrs: {
                                                            placeholder:
                                                              _vm.$t(
                                                                "enterCompanyname"
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form
                                                                .company_name,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "company_name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.company_name",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.form.is_personal == 2 &&
                                    _vm.form.industry_id == 15
                                      ? [
                                          _c(
                                            "a-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "a-form-model-item",
                                                    {
                                                      key: "3",
                                                      attrs: {
                                                        label:
                                                          _vm.$t("Companyname"),
                                                        prop: "company_name",
                                                        required: "",
                                                      },
                                                    },
                                                    [
                                                      _c("a-input", {
                                                        attrs: {
                                                          placeholder:
                                                            _vm.$t(
                                                              "enterCompanyname"
                                                            ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .company_name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "company_name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.company_name",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "a-form-model-item",
                                                    {
                                                      key: "4",
                                                      attrs: {
                                                        label:
                                                          _vm.$t("Companysize"),
                                                        prop: "size_id",
                                                        required: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "a-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              _vm.$t(
                                                                "selectcompanysize"
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form.size_id,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "size_id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.size_id",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.companyList,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "a-select-option",
                                                              {
                                                                key: index,
                                                                class: [
                                                                  _vm.lang,
                                                                ],
                                                                attrs: {
                                                                  value: index,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(item)
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "a-form-model-item",
                                                    {
                                                      key: "9",
                                                      attrs: {
                                                        label:
                                                          _vm.$t("Positon"),
                                                        prop: "role_id",
                                                        required: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "a-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              _vm.$t(
                                                                "selectposition"
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form.role_id,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "role_id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.role_id",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.roleList,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "a-select-option",
                                                              {
                                                                key: index,
                                                                class: [
                                                                  _vm.lang,
                                                                ],
                                                                attrs: {
                                                                  value: index,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.form.role_id == 6
                                                ? _c(
                                                    "a-col",
                                                    {
                                                      attrs: { xs: 24, sm: 12 },
                                                    },
                                                    [
                                                      _c(
                                                        "a-form-model-item",
                                                        {
                                                          key: "10",
                                                          attrs: {
                                                            label:
                                                              _vm.$t(
                                                                "Enteryourposition"
                                                              ),
                                                            prop: "custom_role",
                                                            required: "",
                                                          },
                                                        },
                                                        [
                                                          _c("a-input", {
                                                            attrs: {
                                                              placeholder:
                                                                _vm.$t(
                                                                  "pleaseEnterPos"
                                                                ),
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .custom_role,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.form,
                                                                    "custom_role",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "form.custom_role",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm.form.is_personal == 2 &&
                                    _vm.form.industry_id != 15
                                      ? [
                                          _c(
                                            "a-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "a-form-model-item",
                                                    {
                                                      key: "4",
                                                      attrs: {
                                                        label:
                                                          _vm.$t("Companysize"),
                                                        prop: "size_id",
                                                        required: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "a-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              _vm.$t(
                                                                "selectcompanysize"
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form.size_id,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "size_id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.size_id",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.companyList,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "a-select-option",
                                                              {
                                                                key: index,
                                                                class: [
                                                                  _vm.lang,
                                                                ],
                                                                attrs: {
                                                                  value: index,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(item)
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "a-col",
                                                { attrs: { xs: 24, sm: 12 } },
                                                [
                                                  _c(
                                                    "a-form-model-item",
                                                    {
                                                      key: "9",
                                                      attrs: {
                                                        label:
                                                          _vm.$t("Positon"),
                                                        prop: "role_id",
                                                        required: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "a-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              _vm.$t(
                                                                "selectposition"
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form.role_id,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "role_id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.role_id",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.roleList,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "a-select-option",
                                                              {
                                                                key: index,
                                                                class: [
                                                                  _vm.lang,
                                                                ],
                                                                attrs: {
                                                                  value: index,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _vm.form.role_id == 6
                                                ? _c(
                                                    "a-col",
                                                    {
                                                      attrs: { xs: 24, sm: 12 },
                                                    },
                                                    [
                                                      _c(
                                                        "a-form-model-item",
                                                        {
                                                          key: "10",
                                                          attrs: {
                                                            label:
                                                              _vm.$t(
                                                                "Enteryourposition"
                                                              ),
                                                            prop: "custom_role",
                                                            required: "",
                                                          },
                                                        },
                                                        [
                                                          _c("a-input", {
                                                            attrs: {
                                                              placeholder:
                                                                _vm.$t(
                                                                  "pleaseEnterPos"
                                                                ),
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .custom_role,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.form,
                                                                    "custom_role",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "form.custom_role",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "billInfo" },
                            [
                              _c("div", { staticClass: "section-title" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("BillingAddress"))),
                                ]),
                              ]),
                              _vm.form.id && !_vm.edit
                                ? _c(
                                    "div",
                                    { staticClass: "readonly-view" },
                                    [
                                      _c(
                                        "a-row",
                                        {
                                          staticClass: "ro-row",
                                          attrs: { gutter: 16 },
                                        },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("CountryRegion")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getCountryName(
                                                          _vm.form.country_id
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("State"))
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [_vm._v(_vm._s(_vm.form.state))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        {
                                          staticClass: "ro-row",
                                          attrs: { gutter: 16 },
                                        },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [_vm._v(_vm._s(_vm.$t("City")))]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [_vm._v(_vm._s(_vm.form.city))]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { xs: 24, sm: 12 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ro-label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("ZipCode"))
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ro-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.form.zip_code)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-row",
                                        {
                                          staticClass: "ro-row",
                                          attrs: { gutter: 16 },
                                        },
                                        [
                                          _c("a-col", { attrs: { span: 24 } }, [
                                            _c(
                                              "div",
                                              { staticClass: "ro-label" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("StreetAddress")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "ro-value" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.form.street_address
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.form.id || _vm.edit
                                ? [
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "5",
                                                attrs: {
                                                  label:
                                                    _vm.$t("CountryRegion"),
                                                  prop: "country_id",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select",
                                                  {
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "SelectCountryRegion"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.country_id,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "country_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.country_id",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.locationList,
                                                    function (item, index) {
                                                      return _c(
                                                        "a-select-option",
                                                        {
                                                          key: index,
                                                          class: [_vm.lang],
                                                          attrs: {
                                                            value: item.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.show_name
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "101",
                                                attrs: {
                                                  label: _vm.$t("State"),
                                                  prop: "state",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t(
                                                        "PleaseEnterState"
                                                      ),
                                                  },
                                                  model: {
                                                    value: _vm.form.state,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.state",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "102",
                                                attrs: {
                                                  label:
                                                    _vm.$t("StreetAddress"),
                                                  prop: "street_address",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "PleaseEnterStreetAddress"
                                                    ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.street_address,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "street_address",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.street_address",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "103",
                                                attrs: {
                                                  label: _vm.$t("City"),
                                                  prop: "city",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t("PleaseEnterCity"),
                                                  },
                                                  model: {
                                                    value: _vm.form.city,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "city",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.city",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { xs: 24, sm: 12 } },
                                          [
                                            _c(
                                              "a-form-model-item",
                                              {
                                                key: "102",
                                                attrs: {
                                                  label: _vm.$t("ZipCode"),
                                                  prop: "zip_code",
                                                  required: "",
                                                },
                                              },
                                              [
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t(
                                                        "PleaseEnterZipCode"
                                                      ),
                                                  },
                                                  model: {
                                                    value: _vm.form.zip_code,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "zip_code",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.zip_code",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "wrap-btn" },
                            [
                              !_vm.form.id || _vm.edit
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass: "submit-btn",
                                      attrs: { type: "primary", size: "large" },
                                      on: { click: _vm.submitForm },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Save")))]
                                  )
                                : _vm._e(),
                              _vm.form.id && !_vm.edit
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass: "submit-btn",
                                      attrs: { size: "large" },
                                      on: { click: _vm.editInvoiceInfo },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Edit")))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }